"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconHome', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M7.4 1.2C7.75556 0.933333 8.24444 0.933333 8.6 1.2L14.6 5.7C14.8518 5.88885 15 6.18524 15 6.5V14C15 14.5523 14.5523 15 14 15H10C9.44772 15 9 14.5523 9 14V11H7V14C7 14.5523 6.55228 15 6 15H2C1.44772 15 1 14.5523 1 14V6.5C1 6.18524 1.14819 5.88885 1.4 5.7L7.4 1.2ZM3 7V13H5V10C5 9.44772 5.44772 9 6 9H10C10.5523 9 11 9.44772 11 10V13H13V7L8 3.25L3 7Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M9.4 1.2C9.75556 0.933333 10.2444 0.933333 10.6 1.2L18.6 7.2C18.8518 7.38885 19 7.68524 19 8V18C19 18.5523 18.5523 19 18 19H13C12.4477 19 12 18.5523 12 18V13H8V18C8 18.5523 7.55228 19 7 19H2C1.44772 19 1 18.5523 1 18V8C1 7.68524 1.14819 7.38885 1.4 7.2L9.4 1.2ZM3 8.5V17H6V12C6 11.4477 6.44772 11 7 11H13C13.5523 11 14 11.4477 14 12V17H17V8.5L10 3.25L3 8.5Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M11.4453 2.16795C11.7812 1.94402 12.2188 1.94402 12.5547 2.16795L21.5547 8.16795C21.8329 8.35342 22 8.66565 22 9V21C22 21.5523 21.5523 22 21 22H15C14.4477 22 14 21.5523 14 21V16H10V21C10 21.5523 9.55228 22 9 22H3C2.44772 22 2 21.5523 2 21V9C2 8.66565 2.1671 8.35342 2.4453 8.16795L11.4453 2.16795ZM4 9.53518V20H8V15C8 14.4477 8.44772 14 9 14H15C15.5523 14 16 14.4477 16 15V20H20V9.53518L12 4.20185L4 9.53518Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M15.1235 2.2827C15.6471 1.90577 16.3529 1.90577 16.8765 2.2827L29.3765 11.2827C29.768 11.5646 30 12.0176 30 12.5V28.5C30 29.3284 29.3284 30 28.5 30H20.5C19.6716 30 19 29.3284 19 28.5V21H13V28.5C13 29.3284 12.3284 30 11.5 30H3.5C2.67157 30 2 29.3284 2 28.5V12.5C2 12.0176 2.23203 11.5646 2.62354 11.2827L15.1235 2.2827ZM5 13.2684V27H10V19.5C10 18.6716 10.6716 18 11.5 18H20.5C21.3284 18 22 18.6716 22 19.5V27H27V13.2684L16 5.34835L5 13.2684Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;